import React from 'react';

const Testimonials: React.FC = () => {
  return (
    <>
      <div
        className="
        grid 
        grid-cols-1 lg:grid-cols-6
        gap-4 
        h-auto lg:h-[50vh]      
        min-h-0        
        px-4 lg:px-24 
        pt-4 lg:pt-8
        relative
      "
      >
        {/* 1) Column with mixta.webp (fills height on lg) */}
        <div
          className="
          lg:col-span-2 
          flex 
          flex-col 
          h-full     /* Important: fill parent's height */
          min-h-0 
          overflow-hidden
        "
        >
          <img
            src="https://santaplaya-bucket.s3.amazonaws.com/mixta.webp"
            alt="Tostada Mixta"
            className="h-full w-full object-cover"
          />
        </div>

        {/* 2) Middle column with stacked images */}
        <div
          className="
          lg:col-span-1 
          grid 
          grid-rows-1 lg:grid-rows-3 
          grid-cols-2 lg:grid-cols-1
          gap-4 
          h-full 
          min-h-0
        "
        >
          {/* Top image (2/3 on lg) */}
          <div className="lg:row-span-2 overflow-hidden bg-maroon max-h-[20vh] lg:max-h-full">
            <img
              src="https://santaplaya-bucket.s3.amazonaws.com/simpler_is_better.webp"
              className="h-full w-full object-cover"
            />
          </div>
          {/* Bottom image (1/3 on lg) */}
          <div className="lg:row-span-1 overflow-hidden bg-basic max-h-[20vh] lg:max-h-full">
            <img
              src="https://santaplaya-bucket.s3.amazonaws.com/three_dishes.webp"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        {/* 3) Wide column with testimonial text */}
        <div className="lg:col-span-3 min-h-0 bg-basic place-content-center flex justify-center items-center p-4">
          <p className="text-maroon font-prosto text-sm lg:text-2xl text-center max-w-[40rem]">
            &quot;A must-try! Folks along State were stopping at our table to
            take pictures and ask about it. I suggest a Michelada and the
            Octopus tacos. Loved the entire experience.&quot;
            <br />
            <br />- Janet
          </p>
        </div>
      </div>
      <AnotherRow />
      <div className="flex flex-col pt-4 lg:pt-8 px-4 lg:px-24 max-h-[25vh] overflow-hidden">
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/front.webp"
          alt="Come on in!"
        />
      </div>
      <LastRow />
    </>
  );
};

const AnotherRow: React.FC = () => {
  return (
    <div
      className="
        grid
        grid-cols-1 lg:grid-cols-8
        gap-4
        h-auto lg:h-[50vh]
        min-h-0
        px-4 lg:px-24
        pt-4 lg:pt-8
        relative
      "
    >
      {/* 1) 4 columns: Single image */}
      <div
        className="
          lg:col-span-4
          flex
          flex-col
          h-full
          min-h-0
          overflow-hidden
        "
      >
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/simpler_is_better.webp"
          alt="Baja Fish Taco"
          className="h-full w-full object-cover"
        />
      </div>

      {/* 2) 2 columns: Maroon block with centered text */}
      <div
        className="
          lg:col-span-2
          bg-sea
          flex
          justify-center
          items-center
          p-4
          min-h-0
        "
      >
        <p className="text-white font-prosto text-sm lg:text-md text-center max-w-[40rem]">
          &quot;As a San Diego native I know a good fish taco I&#39;ve had
          hundreds. After moving to sb, there are so many fish tacos around but
          none of them are authentic, legit, or quality. Seriously name any
          I&#39;ve tried it. Santa playa mariscos is where I finally found a
          Baja fish taco in sb that is made correctly. And for a good
          price.&quot;
          <br />
          <br />- Jared P.
        </p>
      </div>

      {/* 3) 2 columns: Another image */}
      <div
        className="
          lg:col-span-2
          flex
          flex-col
          h-full
          min-h-0
          overflow-hidden
        "
      >
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/Michelada.webp"
          alt="Michealada"
          className="h-full w-full object-[30%_100%] object-cover"
        />
      </div>
    </div>
  );
};

const LastRow: React.FC = () => (
  <div
    className="
  grid 
  grid-cols-1 lg:grid-cols-6
  gap-4 
  h-auto lg:h-[50vh]      
  min-h-0        
  px-4 lg:px-24 
  py-4 lg:py-8
  relative
"
  >
    {/* 3) Wide column with testimonial text */}
    <div className="lg:col-span-3 min-h-0 bg-maroon place-content-center flex justify-center items-center p-4">
      <p className="text-white font-prosto text-sm md:text-md xl:text-xl text-center max-w-[40rem] leading-normal">
        Wow! Very fresh & simply delicious mariscos. We had a &#34;mixta&#34;
        tostada (octopus, shrimp & fish ceviche) at one of their little tables
        outside, since we were walking with our pup. Plenty of room inside.
        Looks like a fun place to meet up with friends that enjoy some brews or
        Margaritas with the magnificent food. Delicious salsa & chips & an
        attentive waiter made the whole experience perfect. We&#39;ll be back
        soon!
        <br />
        <br />- Missy H.
      </p>
    </div>
    {/* 1) Column with mixta.webp (fills height on lg) */}
    <div
      className="
    lg:col-span-2 
    flex 
    flex-col 
    h-full     /* Important: fill parent's height */
    min-h-0 
    overflow-hidden
  "
    >
      <img
        src="https://santaplaya-bucket.s3.amazonaws.com/mixta.webp"
        alt="Tostada Mixta"
        className="h-full w-full object-cover"
      />
    </div>

    {/* 2) Middle column with stacked images */}
    <div
      className="
    lg:col-span-1 
    grid 
    grid-rows-1 lg:grid-rows-3 
    grid-cols-2 lg:grid-cols-1
    gap-4 
    h-full 
    min-h-0
  "
    >
      {/* Top image (2/3 on lg) */}
      <div className="lg:row-span-2 overflow-hidden bg-maroon max-h-[20vh] lg:max-h-full">
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/simpler_is_better.webp"
          className="h-full w-full object-cover"
        />
      </div>
      {/* Bottom image (1/3 on lg) */}
      <div className="lg:row-span-1 overflow-hidden bg-basic max-h-[20vh] lg:max-h-full">
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/three_dishes.webp"
          className="h-full w-full object-cover"
        />
      </div>
    </div>
  </div>
);

export default Testimonials;
